var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_elimina",
    "data-name": "icona elimina",
    transform: "translate(-442 -52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(443.524 52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_122",
    "data-name": "Tracciato 122",
    d: "M222.771,154.7a.374.374,0,0,0-.373.375v7.082a.373.373,0,1,0,.747,0v-7.082A.374.374,0,0,0,222.771,154.7Zm0,0",
    transform: "translate(-214.092 -148.906)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_123",
    "data-name": "Tracciato 123",
    d: "M104.771,154.7a.374.374,0,0,0-.373.375v7.082a.373.373,0,1,0,.747,0v-7.082A.374.374,0,0,0,104.771,154.7Zm0,0",
    transform: "translate(-100.499 -148.906)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_124",
    "data-name": "Tracciato 124",
    d: "M1.057,4.762v9.232a2.071,2.071,0,0,0,.548,1.426A1.836,1.836,0,0,0,2.94,16h7.066a1.836,1.836,0,0,0,1.334-.579,2.071,2.071,0,0,0,.548-1.426V4.762a1.432,1.432,0,0,0-.366-2.815H9.61V1.479A1.469,1.469,0,0,0,8.131,0H4.815a1.469,1.469,0,0,0-1.479,1.48v.468H1.423a1.432,1.432,0,0,0-.366,2.815Zm8.949,10.487H2.94A1.185,1.185,0,0,1,1.8,13.994v-9.2h9.337v9.2a1.185,1.185,0,0,1-1.135,1.255ZM4.083,1.479A.721.721,0,0,1,4.815.748H8.131a.721.721,0,0,1,.732.731v.468H4.083ZM1.423,2.7h10.1a.674.674,0,0,1,0,1.349H1.423a.674.674,0,0,1,0-1.349Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_125",
    "data-name": "Tracciato 125",
    d: "M163.771,154.7a.374.374,0,0,0-.373.375v7.082a.373.373,0,1,0,.747,0v-7.082A.374.374,0,0,0,163.771,154.7Zm0,0",
    transform: "translate(-157.295 -148.906)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1828",
    "data-name": "Rettangolo 1828",
    transform: "translate(442 52)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.63ce0c96fe5e6c23ac5d3b11804a72b4.svg";
export { ForwardRef as ReactComponent };